var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1321 4784 c-169 -45 -301 -180 -346 -351 -23 -86 -23 -3020 0 -3106 45 -173 178 -307 350 -352 52 -13 244 -15 1555 -15 1311 0 1503 2 1555 15 172 45 305 179 350 352 23 86 23 3020 0 3106 -45 173 -178 307 -350 352 -87 22 -3030 22 -3114 -1z m3085 -330 c15 -11 37 -33 48 -48 21 -27 21 -28 21 -1526 0 -1498 0 -1499 -21 -1526 -11 -15 -33 -37 -48 -48 -27 -21 -28 -21 -1526 -21 -1498 0 -1499 0 -1526 21 -15 11 -37 33 -48 48 -21 27 -21 31 -24 1499 -1 810 0 1486 3 1504 7 40 49 91 90 109 25 11 296 13 1517 11 1484 -2 1487 -2 1514 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2175 3664 c-46 -24 -74 -54 -86 -93 -6 -24 -9 -267 -7 -713 3 -665 3 -677 24 -704 33 -45 70 -67 121 -71 47 -5 67 4 703 322 360 180 668 336 684 348 41 29 70 99 62 151 -14 86 -4 80 -727 441 -708 355 -707 354 -774 319z m975 -784 c0 -3 -169 -89 -375 -193 l-375 -187 0 380 0 380 375 -187 c206 -104 375 -190 375 -193z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 4146 c-37 -17 -70 -52 -84 -89 -8 -20 -11 -532 -11 -1671 0 -1789 -3 -1691 56 -1808 59 -116 197 -221 326 -247 37 -8 544 -10 1705 -9 1650 3 1652 3 1679 24 53 39 69 71 69 134 0 63 -16 95 -69 134 -27 21 -30 21 -1686 26 -1656 5 -1659 5 -1686 26 -15 11 -37 33 -48 48 -21 27 -21 30 -26 1686 -5 1656 -5 1659 -26 1686 -11 15 -32 37 -46 47 -34 25 -113 32 -153 13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetLibrary);
export default __webpack_public_path__ + "static/media/asset-library.5740c73af00aa863c9395c0f6c3de836.svg";
export { ForwardRef as ReactComponent };